// The environment the workflow's Test and Run now use. With one environment there is nothing to pick. With
// several, the person's pick when it is still one of them, else the company default when the workflow runs
// in it, else the first — preselected where the person can see and change it, never chosen out of sight.
const pickWorkflowRunEnvironment = ({ runEnvironments, pickedEnvironmentId, environments }) => {
  if (runEnvironments.length <= 1) {
    return runEnvironments[0] || null;
  }

  const defaultEnvironmentId = environments.find((environment) => environment?.isDefault === true)?.id || null;

  return runEnvironments.find((environment) => environment.id === pickedEnvironmentId) || runEnvironments.find((environment) => environment.id === defaultEnvironmentId) || runEnvironments[0];
};

export default pickWorkflowRunEnvironment;
